import ApiCallService from "./ApiCallService";

const VISIT_ENDPOINT =
  `${process.env.REACT_APP_BASE_URL}/sadhu-sadhvi-visit`;

const getList = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const getRecord = (response) => {
  if (response?.data && !Array.isArray(response.data)) {
    return response.data;
  }
  return response || null;
};

const uploadFile = async (file, endpoint) => {
  if (!file) return "";

  // If file is already a remote URL or key, return it as-is.
  if (typeof file === "string") return file;

  const formData = new FormData();
  formData.append("file", file);
  try {
    const response = await ApiCallService.upload(endpoint, formData);

    return (
      response?.s3Key ||
      response?.document ||
      response?.url ||
      response?.key ||
      response?.data?.s3Key ||
      response?.data?.document ||
      response?.data?.url ||
      ""
    );
  } catch (err) {
    console.error("Failed uploading file to", endpoint, err?.response || err);
    // Surface backend message when available
    const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || "Upload failed";
    throw new Error(msg);
  }
};

const SadhuSadhviVisitService = {
  async getStates() {
    return getList(
      await ApiCallService.get(`${process.env.REACT_APP_BASE_URL}/states`),
    );
  },

  async getDistricts(stateId) {
    return getList(
      await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/state/${stateId}/district`,
      ),
    );
  },

  async getTalukas(districtId) {
    return getList(
      await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/district/${districtId}/taluka`,
      ),
    );
  },

  async getVillages(talukaId) {
    return getList(
      await ApiCallService.get(
        `${process.env.REACT_APP_BASE_URL}/taluka/${talukaId}/village`,
      ),
    );
  },

  async getMyVisits() {
    return getList(await ApiCallService.get(VISIT_ENDPOINT));
  },

  async getMyVisitById(id) {
    return getRecord(await ApiCallService.get(`${VISIT_ENDPOINT}/${id}`));
  },
  async getMySadhuSadhviVisits() {
    return getList(await ApiCallService.get(`${VISIT_ENDPOINT}/mine`));
  },

  async submitVisit(values, files) {
    const imageUploadEndpoint = `${process.env.REACT_APP_BASE_URL}/upload/document/image`;

    const [visitPhoto1, visitPhoto2] = await Promise.all([
      uploadFile(files.visitPhoto1, imageUploadEndpoint),
      uploadFile(files.visitPhoto2, imageUploadEndpoint),
    ]);

    return ApiCallService.post(VISIT_ENDPOINT, {
      ...values,
      visitPhoto1,
      visitPhoto2,
    });
  },
};

export default SadhuSadhviVisitService;
